import { useMemo } from 'react'
import { MdOutlineAssignmentInd } from 'react-icons/md'

import { userManager } from '@/Core/Managers'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'

import { TaskResource } from '../Resources/TaskResource'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Мої завдання» — я серед виконавців (SPEC-008 §4.4).
 * prefilter `{ responsibles: <я> }` → `filters={"and":[{responsibles.uuid = <me>}]}`.
 */
export default function MyTasksPage() {
    const listContext = useMemo(
        () =>
            createCrudResourceContext({
                contextType: 'list',
                registryKey: 'Task.My.list',
                resource: TaskResource,
                prefilter: { responsibles: userManager.user },
                // Каст на межі нетипізованої .jsx-фабрики: її inferred-параметр не містить
                // resource/prefilter/list (їх фабрика читає через ...props у рантаймі).
                // Приводимо до її ж параметра — без `any` (пор. Core `UniversalResourcePage.tsx:70`).
            } as unknown as Parameters<typeof createCrudResourceContext>[0]),
        []
    )

    // `registryKey` дублює ключ із crudContext, але тип `ResourceList` ЦІЛІ вимагає його
    // як обов'язковий проп (на відміну від autostrada, де він опційний) — лишаємо свідомо.
    return <ResourceList crudContext={listContext} registryKey="Task.My.list" />
}

export const pageConfig: IPageConfig = {
    key: 'Task.My',
    title: 'Мої завдання',
    icon: <MdOutlineAssignmentInd />,
}
